function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Shop = function Shop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M4.245 8.776A2.75 2.75 0 0 1 6.986 6.25h10.028a2.75 2.75 0 0 1 2.74 2.526l.817 10a2.75 2.75 0 0 1-2.741 2.974H6.17a2.75 2.75 0 0 1-2.741-2.974zM6.986 7.75c-.65 0-1.193.5-1.246 1.148l-.816 10A1.25 1.25 0 0 0 6.17 20.25h11.66a1.25 1.25 0 0 0 1.246-1.352l-.816-10a1.25 1.25 0 0 0-1.246-1.148z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M4.245 8.776A2.75 2.75 0 0 1 6.986 6.25h10.028a2.75 2.75 0 0 1 2.74 2.526l.817 10a2.75 2.75 0 0 1-2.741 2.974H6.17a2.75 2.75 0 0 1-2.741-2.974zM6.986 7.75c-.65 0-1.193.5-1.246 1.148l-.816 10A1.25 1.25 0 0 0 6.17 20.25h11.66a1.25 1.25 0 0 0 1.246-1.352l-.816-10a1.25 1.25 0 0 0-1.246-1.148z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M8.75 6.512c.04-1.256.438-2.194 1.005-2.81.565-.612 1.34-.952 2.245-.952.933 0 1.727.314 2.289.896.561.582.96 1.505.96 2.854v2a.75.75 0 0 0 1.5 0v-2c0-1.65-.495-2.978-1.381-3.896S13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.857.929-1.355 2.237-1.403 3.791V8.5a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M8.75 6.512c.04-1.256.438-2.194 1.005-2.81.565-.612 1.34-.952 2.245-.952.933 0 1.727.314 2.289.896.561.582.96 1.505.96 2.854v2a.75.75 0 0 0 1.5 0v-2c0-1.65-.495-2.978-1.381-3.896S13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.857.929-1.355 2.237-1.403 3.791V8.5a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }));
};
export default Shop;
Shop.displayName = 'Shop';